import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { RoleDashboard } from "@/components/crm/RoleDashboard";
import { DeptPipeline } from "@/components/crm/hub/DeptPipeline";

export default function TeamOverview() {
  const [role, setRole] = useState(null);
  const loadRole = useCallback((view = "") => api.get("/dashboard/role", { params: { view } }).then((r) => setRole(r.data)).catch((e) => setRole(e.response?.status === 403 && !view ? { denied: true } : { error: e.response?.data?.detail || "Dashboard unavailable" })), []);
  useEffect(() => { loadRole(); }, [loadRole]);
  if (role?.denied) return <Navigate to="/" replace />;
  return (
    <>
      <div className="fade-up">
        <h1 data-testid="page-title" className="text-2xl font-bold tracking-tight text-zinc-900 sm:text-[28px]">Team overview</h1>
        <p className="mt-1 text-sm text-zinc-500">Department pipelines and your team's work — your personal portal stays on Home.</p>
      </div>
      <DeptPipeline />
      {role?.error && <div data-testid="role-dashboard-error" className="rounded-xl border border-rose-400/40 p-4 text-sm text-rose-500">{String(role.error)}</div>}
      {role?.view && <RoleDashboard data={role} onView={loadRole} />}
    </>
  );
}
